
// @ts-nocheck





import { i18nText } from '@/locales';


import {Modal, FormModel} from 'ant-design-vue';
import {Component} from "vue-property-decorator";
import PageTitle from "@/UI/components/common/PageTitle.vue";
import {mixins} from "vue-class-component";
import BaseDataForm from "@/UI/components/Helpers/BaseForm/BaseDataForm.vue";
import {SimpleProxyForm} from "@/UI/components/Helpers/SimpleProxyForm";
import {ClientLoyaltyTableMix} from "@/UI/mixins/Loaylty/ClientLoyaltyTableMix";
import {SubscriptionMix} from "@/UI/mixins/Loaylty/SubscriptionMix";
import {LoyaltySubscriptionStore} from "@/store/modules/Loyalty/Subscription/LoyaltySubscription";
import moment from "moment";
import {SubscriptionTableMix} from "@/UI/mixins/Loaylty/SubscriptionTableMix";
import {LoyaltySubscriptionTypeStore} from "@/store/modules/Loyalty/Subscription/LoyaltySubscriptionType";
import LoyaltySubscriptionUpdateComponent
  from "@/UI/components/forms/loyalty/loyaltySubscription/loyaltySubscription/LoyaltySubscriptionUpdateComponent.vue";
import {LoyaltySubscriptionAddRequestType} from "@/form/loyalty/loyaltySubscription/loyaltySubscription.types";
import {TableColumns} from "@/UI/pages/loyalty/lib/table";
import {SubscriptionTypeMix} from '@/UI/mixins/Loaylty/SubscriptionTypeMix';
import {
  ILoyaltySubscriptionType
} from "@/entity/loyalty/loyaltySubscription/loyaltySubscriptionType/LoyaltySubscriptionType.types";
import {getStudioId} from '@/UI/lib/state';
import {NewProxyDataForm} from '@/UI/components/Helpers/NewProxyDataForm';
import {CashboxStore} from "@/store/modules/Finance/Cashbox";
import {ClientsMix} from '@/UI/mixins/ClientsMix';
import {ClientsStore} from '@/store/modules/Clients';
import {
  loyaltySubscriptionForm as loyaltySubscriptionForm,
  FormRules as SubscriptionFormRules
} from "@/form/loyalty/loyaltySubscription/loyaltySubscription";
import {SearchinStore} from "@/UI/Decorators/decorator";
import {ICashboxListItem} from "@/entity/finance/cashbox/cashbox.types";
import {appPaginationStore} from "@/store/modules/appPagination";
import {ProxyGetData} from "@/UI/components/Helpers/getData";
import SortComponent from "@/UI/components/Helpers/components/SortComponent.vue"
import {appFiltersStore} from "@/store/modules/appFilters";

@Component({
  components: {
    SortComponent,
    PageTitle,
    LoyaltySubscriptionUpdateComponent,
    BaseDataForm,
    "a-modal": Modal,
    "a-form-model": FormModel,
    "a-form-model-item": FormModel.Item
  },
  methods: {moment},
})
export default class Subscriptions extends mixins(
  //NewProxyDataForm,
  SimpleProxyForm,
  ClientLoyaltyTableMix,
  ClientsMix,
  SubscriptionMix,
  SubscriptionTableMix,
  SubscriptionTypeMix,
  TableColumns,
  ProxyGetData,
) {
  showModal = false;
  form = new loyaltySubscriptionForm();
  data: any = [];
  modalTitle = '';
  SubscriptionFormRules = SubscriptionFormRules;
  subscriptionEditMode = 0

  activeTo(r: any) {
    return moment(r.active_to).format("DD.MM.YYYY");
  }

  activeFrom(r: any) {
    return moment(r.active_from).format("DD.MM.YYYY");
  }

  // create subscription
  async fetchTotalSum(): Promise<void> {
    let total_sum = LoyaltySubscriptionTypeStore.loyaltySubscriptionTypes?.data.find((item: any) => {
      return item.id === this.form.membership_type_id;
    });
    if (total_sum?.price) {
      this.form.total_sum = Number(total_sum?.price);
    }
    if (this.form.membership_type_id) {
      this.form.total_sum =
        Number(this.form.total_sum) - (Number(total_sum?.price) * Number(this.form.discount)) / 100;
    }
    if (!this.form.cashbox_sum) {
      this.form.cashbox_sum = this.form.total_sum;
    }
  }

  async SearchClients(value: string): Promise<void> {
    await ClientsStore.fetchAll({
      limit: this.AppPageParams.pageSize,
      filter: {salon_id: this.$store.state.salon_id, name: value},
    });
  }

  async searchDataTypes(value: string): Promise<void> {
    await LoyaltySubscriptionTypeStore.fetchAll({limit: 10, filter: {name: value}, salon_id: getStudioId(this)});
  }

  async createSubscription(): Promise<void> {
    await LoyaltySubscriptionTypeStore.fetchAll({
      limit: this.AppPageParams.pageSize,
      filter: {salon_id: this.$store.state.salon_id},
    });
    await this.SearchClients("");
    this.form = new loyaltySubscriptionForm();
    this.showModal = true;
    this.subscriptionEditMode = 0;
    this.form.client_id = parseInt(this.$route.params.id);
  }

  onPay(): void {
    this.form.proceed_payment = true;
    this.subsriptionOnSubmit();
  }

  subsriptionOnSubmit(): void {
    (this.$refs.subscriptionForm as FormModel).validate(async (valid) => {
      if (valid) {
        if (this.subscriptionEditMode === 0) {
          try {
            this.form.salon_id = this.$store.state["salon_id"];
            let response = await LoyaltySubscriptionStore.create(this.form);

            if (response && response.status) {
              this.$message.success(response.response);
              await this.getData();
              await LoyaltySubscriptionTypeStore.fetchAll({
                limit: this.AppPageParams.pageSize,
                filter: {salon_id: getStudioId(this)}
              });
              this.showModal = false;
            } else {
              this.$message.error(response.response);
            }
          } catch (e) {
            console.log(e);
          }
        }
        if (this.subscriptionEditMode === 1) {
          let response = await LoyaltySubscriptionStore.update(this.form);
          if (response && response.status) {
            this.$message.success(response.response);
            await this.getData();
            this.showModal = false;
          } else {
            this.$message.error(response.response);
          }
        }
      }
    });
  }

  handleCancel(): void {
    this.showModal = false;
  }

  @SearchinStore
  hSearch(source: string, value: string, useStudio: boolean): void {
  }

  handleSearchCashboxes(value: string): void {
    this.hSearch("cashbox", value, true);
  }

  get cashbox(): any {
    return CashboxStore.items?.data;
  }

  // get client(): any {
  //     return  ClientsStore.fetchData({ filter: { client_id: parseInt(this.$route.params.id) } })
  // }

  get cashboxes(): ICashboxListItem[] | undefined {
    return CashboxStore.items?.data;
  }

  get loyaltySubscriptionTypes(): ILoyaltySubscriptionType | null {
    return LoyaltySubscriptionTypeStore.loyaltySubscriptionTypes;
  }

  async created(): Promise<void> {
    console.clear();
    this.tableLoad = false;
    if (!this.formReady) {
      try {
        this.proxyFilter = {
          client_id: parseInt(this.$route.params.id)
        };
        appPaginationStore.setCurrent(1);
        await this.sortedData("desc", {dataIndex: "created_at"});
        await CashboxStore.fetchAll({filter: {salon_id: getStudioId(this)}});
        this.formReady = true;
        this.tableLoad = true;
      } catch (e) {
        console.log("Error loading accounts");
      }
    }
  }

  /*  */

  async getSelectedType(recordId: number | null): Promise<any> {
    if (!recordId) return;

    const selectedType = await LoyaltySubscriptionTypeStore.fetchSubscriptionTypeById({
      filter: {id: recordId},
    });
    if (this.loyaltySubscriptionTypes && this.loyaltySubscriptionTypes.data?.length > 10) {
      this.loyaltySubscriptionTypes?.data.shift();
    }
    this.loyaltySubscriptionTypes?.data.unshift(selectedType.data[0]);
  }

  async editCard(record: LoyaltySubscriptionAddRequestType): Promise<void> {
    this.form.setFormData(record);
    this.form.total_sum = Number(record.total_sum);
    this.form.client_id = parseInt(this.$route.params.id);
    this.form.cashbox_id = 0;
    this.form.cashbox_sum = 0;
    await this.getSelectedType(record.membership_type_id);
    this.showModal = true;
  }

  subscribeHandleCancel(): void {
    this.showModal = false;
  }

  dateSale(record: Record<any, any>): string {
    return moment(record.created_at).format("DD MMMM yyyy" + " " + i18nText("в") + " " + "HH:mm");
  }

  dateActivated(record: Record<any, any>): string {
    return moment(record.created_at).format("DD MMMM yyyy" + " " + i18nText("в") + " " + "HH:mm");
  }

  dateActiveTo(record: Record<any, any>): string {
    return record.active_to
      ? moment(record.active_to).format("DD MMMM yyyy") + " " + i18nText("в") + " " + record.active_to.substr(11, 5)
      : "";
  }

  async setFilter({by, sort}: { by: string; sort: any }): Promise<void> {
    //await this.filterData(appFiltersStore.filter);
    await this.sortedData(by, {dataIndex: sort.dataIndex});
  }

  async clearFilter(clear: string): Promise<void> {
    await this.sortedData("desc", {dataIndex: "active_from"});
  }
}
